import React, { Fragment } from "react";
import { useForm } from "react-hook-form";
import updateAction from "./updateAction";
import Button from "../../../../components/ui/button";
import { Title,Textarea ,NextButton} from "./free-consultation-steps.style";
import { Col } from "../../../../components/ui/wrapper";
import { useStateMachine } from "little-state-machine";
import { ErrorStepSection } from './ErrorStepsSection';

const StepSix = ({ count, setCount }) => {
    const { register, handleSubmit, formState: { errors } } = useForm({
      mode: "onBlur",
    });
    const { actions, state } = useStateMachine({updateAction});
  
    const onSubmit = (data) => {
      actions.updateAction(data);
      setCount(count + 1);
    };
  
    const onPreviousState = () => {
      setCount(count - 1);
    };
  
    return (
      <Fragment>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Title>Describe your project briefly</Title>
          <Textarea
            type="text"
            {...register('projectDesc', { required: "Project description is required" })}
            id="projectDesc"
            placeholder="Project description *"
            defaultValue={state?.data?.projectDesc} />
          
          <ErrorStepSection 
            field="projectDesc" 
            errors={errors} 
            errorMessage={errors?.projectDesc?.message}
            stepNumber={5}
          /> 

          <Col lg={12}>
            <Button 
              mt="30px"
              skin="dark"
              onClick={(e) => onPreviousState()}
            >
              Back
            </Button>
            <NextButton hover={3} skin='secondary'>
              Next
            </NextButton>
          </Col>
        </form>
      </Fragment>
    );
  };

  export {StepSix}